!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ReactSweetAlert = e() : t.ReactSweetAlert = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(o) {
      if (e[o]) return e[o].exports;
      var a = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var a in t) {
        n.d(o, a, function (e) {
          return t[e];
        }.bind(null, a));
      }
      return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 6);
  }([function (t, e, n) {
    t.exports = n(9)();
  }, function (t, e, n) {
    var o;
    !function (a, r, s) {
      if (a) {
        for (var i, l = {
          8: "backspace",
          9: "tab",
          13: "enter",
          16: "shift",
          17: "ctrl",
          18: "alt",
          20: "capslock",
          27: "esc",
          32: "space",
          33: "pageup",
          34: "pagedown",
          35: "end",
          36: "home",
          37: "left",
          38: "up",
          39: "right",
          40: "down",
          45: "ins",
          46: "del",
          91: "meta",
          93: "meta",
          224: "meta"
        }, c = {
          106: "*",
          107: "+",
          109: "-",
          110: ".",
          111: "/",
          186: ";",
          187: "=",
          188: ",",
          189: "-",
          190: ".",
          191: "/",
          192: "`",
          219: "[",
          220: "\\",
          221: "]",
          222: "'"
        }, u = {
          "~": "`",
          "!": "1",
          "@": "2",
          "#": "3",
          $: "4",
          "%": "5",
          "^": "6",
          "&": "7",
          "*": "8",
          "(": "9",
          ")": "0",
          _: "-",
          "+": "=",
          ":": ";",
          '"': "'",
          "<": ",",
          ">": ".",
          "?": "/",
          "|": "\\"
        }, p = {
          option: "alt",
          command: "meta",
          return: "enter",
          escape: "esc",
          plus: "+",
          mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
        }, d = 1; d < 20; ++d) {
          l[111 + d] = "f" + d;
        }

        for (d = 0; d <= 9; ++d) {
          l[d + 96] = d.toString();
        }

        b.prototype.bind = function (t, e, n) {
          return t = t instanceof Array ? t : [t], this._bindMultiple.call(this, t, e, n), this;
        }, b.prototype.unbind = function (t, e) {
          return this.bind.call(this, t, function () {}, e);
        }, b.prototype.trigger = function (t, e) {
          return this._directMap[t + ":" + e] && this._directMap[t + ":" + e]({}, t), this;
        }, b.prototype.reset = function () {
          return this._callbacks = {}, this._directMap = {}, this;
        }, b.prototype.stopCallback = function (t, e) {
          if ((" " + e.className + " ").indexOf(" mousetrap ") > -1) return !1;
          if (function t(e, n) {
            return null !== e && e !== r && (e === n || t(e.parentNode, n));
          }(e, this.target)) return !1;

          if ("composedPath" in t && "function" == typeof t.composedPath) {
            var n = t.composedPath()[0];
            n !== t.target && (e = n);
          }

          return "INPUT" == e.tagName || "SELECT" == e.tagName || "TEXTAREA" == e.tagName || e.isContentEditable;
        }, b.prototype.handleKey = function () {
          return this._handleKey.apply(this, arguments);
        }, b.addKeycodes = function (t) {
          for (var e in t) {
            t.hasOwnProperty(e) && (l[e] = t[e]);
          }

          i = null;
        }, b.init = function () {
          var t = b(r);

          for (var e in t) {
            "_" !== e.charAt(0) && (b[e] = function (e) {
              return function () {
                return t[e].apply(t, arguments);
              };
            }(e));
          }
        }, b.init(), a.Mousetrap = b, t.exports && (t.exports = b), void 0 === (o = function () {
          return b;
        }.call(e, n, e, t)) || (t.exports = o);
      }

      function f(t, e, n) {
        t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent("on" + e, n);
      }

      function m(t) {
        if ("keypress" == t.type) {
          var e = String.fromCharCode(t.which);
          return t.shiftKey || (e = e.toLowerCase()), e;
        }

        return l[t.which] ? l[t.which] : c[t.which] ? c[t.which] : String.fromCharCode(t.which).toLowerCase();
      }

      function w(t) {
        return "shift" == t || "ctrl" == t || "alt" == t || "meta" == t;
      }

      function h(t, e, n) {
        return n || (n = function () {
          if (!i) for (var t in i = {}, l) {
            t > 95 && t < 112 || l.hasOwnProperty(t) && (i[l[t]] = t);
          }
          return i;
        }()[t] ? "keydown" : "keypress"), "keypress" == n && e.length && (n = "keydown"), n;
      }

      function g(t, e) {
        var n,
            o,
            a,
            r = [];

        for (n = function (t) {
          return "+" === t ? ["+"] : (t = t.replace(/\+{2}/g, "+plus")).split("+");
        }(t), a = 0; a < n.length; ++a) {
          o = n[a], p[o] && (o = p[o]), e && "keypress" != e && u[o] && (o = u[o], r.push("shift")), w(o) && r.push(o);
        }

        return {
          key: o,
          modifiers: r,
          action: e = h(o, r, e)
        };
      }

      function b(t) {
        var e = this;
        if (t = t || r, !(e instanceof b)) return new b(t);
        e.target = t, e._callbacks = {}, e._directMap = {};
        var n,
            o = {},
            a = !1,
            s = !1,
            i = !1;

        function l(t) {
          t = t || {};
          var e,
              n = !1;

          for (e in o) {
            t[e] ? n = !0 : o[e] = 0;
          }

          n || (i = !1);
        }

        function c(t, n, a, r, s, i) {
          var l,
              c,
              u,
              p,
              d = [],
              f = a.type;
          if (!e._callbacks[t]) return [];

          for ("keyup" == f && w(t) && (n = [t]), l = 0; l < e._callbacks[t].length; ++l) {
            if (c = e._callbacks[t][l], (r || !c.seq || o[c.seq] == c.level) && f == c.action && ("keypress" == f && !a.metaKey && !a.ctrlKey || (u = n, p = c.modifiers, u.sort().join(",") === p.sort().join(",")))) {
              var m = !r && c.combo == s,
                  h = r && c.seq == r && c.level == i;
              (m || h) && e._callbacks[t].splice(l, 1), d.push(c);
            }
          }

          return d;
        }

        function u(t, n, o, a) {
          e.stopCallback(n, n.target || n.srcElement, o, a) || !1 === t(n, o) && (function (t) {
            t.preventDefault ? t.preventDefault() : t.returnValue = !1;
          }(n), function (t) {
            t.stopPropagation ? t.stopPropagation() : t.cancelBubble = !0;
          }(n));
        }

        function p(t) {
          "number" != typeof t.which && (t.which = t.keyCode);
          var n = m(t);
          n && ("keyup" != t.type || a !== n ? e.handleKey(n, function (t) {
            var e = [];
            return t.shiftKey && e.push("shift"), t.altKey && e.push("alt"), t.ctrlKey && e.push("ctrl"), t.metaKey && e.push("meta"), e;
          }(t), t) : a = !1);
        }

        function d(t, e, r, s) {
          function c(e) {
            return function () {
              i = e, ++o[t], clearTimeout(n), n = setTimeout(l, 1e3);
            };
          }

          function p(e) {
            u(r, e, t), "keyup" !== s && (a = m(e)), setTimeout(l, 10);
          }

          o[t] = 0;

          for (var d = 0; d < e.length; ++d) {
            var f = d + 1 === e.length ? p : c(s || g(e[d + 1]).action);
            h(e[d], f, s, t, d);
          }
        }

        function h(t, n, o, a, r) {
          e._directMap[t + ":" + o] = n;
          var s,
              i = (t = t.replace(/\s+/g, " ")).split(" ");
          i.length > 1 ? d(t, i, n, o) : (s = g(t, o), e._callbacks[s.key] = e._callbacks[s.key] || [], c(s.key, s.modifiers, {
            type: s.action
          }, a, t, r), e._callbacks[s.key][a ? "unshift" : "push"]({
            callback: n,
            modifiers: s.modifiers,
            action: s.action,
            seq: a,
            level: r,
            combo: t
          }));
        }

        e._handleKey = function (t, e, n) {
          var o,
              a = c(t, e, n),
              r = {},
              p = 0,
              d = !1;

          for (o = 0; o < a.length; ++o) {
            a[o].seq && (p = Math.max(p, a[o].level));
          }

          for (o = 0; o < a.length; ++o) {
            if (a[o].seq) {
              if (a[o].level != p) continue;
              d = !0, r[a[o].seq] = 1, u(a[o].callback, n, a[o].combo, a[o].seq);
            } else d || u(a[o].callback, n, a[o].combo);
          }

          var f = "keypress" == n.type && s;
          n.type != i || w(t) || f || l(r), s = d && "keydown" == n.type;
        }, e._bindMultiple = function (t, e, n) {
          for (var o = 0; o < t.length; ++o) {
            h(t[o], e, n);
          }
        }, f(t, "keypress", p), f(t, "keydown", p), f(t, "keyup", p);
      }
    }("undefined" != typeof window ? window : null, "undefined" != typeof window ? document : null);
  }, function (t, e, n) {
    "use strict";

    t.exports = n(7);
  }, function (t, e, n) {
    t.exports = function () {
      "use strict";

      function t(e) {
        return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(e);
      }

      function e(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function n(t, e) {
        for (var n = 0; n < e.length; n++) {
          var o = e[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
        }
      }

      function o() {
        return (o = Object.assign || function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];

            for (var o in n) {
              Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
            }
          }

          return t;
        }).apply(this, arguments);
      }

      function a(t) {
        return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
      }

      function r(t, e) {
        return (r = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        })(t, e);
      }

      function s(t, e, n) {
        return (s = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (t) {
            return !1;
          }
        }() ? Reflect.construct : function (t, e, n) {
          var o = [null];
          o.push.apply(o, e);
          var a = Function.bind.apply(t, o),
              s = new a();
          return n && r(s, n.prototype), s;
        }).apply(null, arguments);
      }

      function i(t, e) {
        return !e || "object" != typeof e && "function" != typeof e ? function (t) {
          if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(t) : e;
      }

      function l(t, e, n) {
        return (l = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
          var o = function (t, e) {
            for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = a(t));) {
              ;
            }

            return t;
          }(t, e);

          if (o) {
            var r = Object.getOwnPropertyDescriptor(o, e);
            return r.get ? r.get.call(n) : r.value;
          }
        })(t, e, n || t);
      }

      var c = function c(t) {
        return Array.prototype.slice.call(t);
      },
          u = function u(t) {
        var e = [];
        return "undefined" != typeof Map && t instanceof Map ? t.forEach(function (t, n) {
          e.push([n, t]);
        }) : Object.keys(t).forEach(function (n) {
          e.push([n, t[n]]);
        }), e;
      },
          p = function p(t) {
        console.warn("".concat("SweetAlert2:", " ").concat(t));
      },
          d = function d(t) {
        console.error("".concat("SweetAlert2:", " ").concat(t));
      },
          f = [],
          m = function m(t) {
        return "function" == typeof t ? t() : t;
      },
          w = function w(t) {
        return t && Promise.resolve(t) === t;
      },
          h = Object.freeze({
        cancel: "cancel",
        backdrop: "backdrop",
        close: "close",
        esc: "esc",
        timer: "timer"
      }),
          g = function g(t) {
        var e = {};

        for (var n in t) {
          e[t[n]] = "swal2-" + t[n];
        }

        return e;
      },
          b = g(["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "toast", "toast-shown", "toast-column", "fade", "show", "hide", "noanimation", "close", "title", "header", "content", "actions", "confirm", "cancel", "footer", "icon", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl"]),
          y = g(["success", "warning", "info", "question", "error"]),
          v = {
        previousBodyPadding: null
      },
          k = function k(t, e) {
        return t.classList.contains(e);
      },
          x = function x(t) {
        if (t.focus(), "file" !== t.type) {
          var e = t.value;
          t.value = "", t.value = e;
        }
      },
          C = function C(t, e, n) {
        t && e && ("string" == typeof e && (e = e.split(/\s+/).filter(Boolean)), e.forEach(function (e) {
          t.forEach ? t.forEach(function (t) {
            n ? t.classList.add(e) : t.classList.remove(e);
          }) : n ? t.classList.add(e) : t.classList.remove(e);
        }));
      },
          O = function O(t, e) {
        C(t, e, !0);
      },
          S = function S(t, e) {
        C(t, e, !1);
      },
          P = function P(t, e) {
        for (var n = 0; n < t.childNodes.length; n++) {
          if (k(t.childNodes[n], e)) return t.childNodes[n];
        }
      },
          B = function B(t) {
        t.style.opacity = "", t.style.display = t.id === b.content ? "block" : "flex";
      },
          E = function E(t) {
        t.style.opacity = "", t.style.display = "none";
      },
          j = function j(t) {
        return !(!t || !(t.offsetWidth || t.offsetHeight || t.getClientRects().length));
      },
          A = function A() {
        return document.body.querySelector("." + b.container);
      },
          T = function T(t) {
        var e = A();
        return e ? e.querySelector(t) : null;
      },
          _ = function _(t) {
        return T("." + t);
      },
          L = function L() {
        return _(b.popup);
      },
          M = function M() {
        var t = L();
        return c(t.querySelectorAll("." + b.icon));
      },
          R = function R() {
        return _(b.title);
      },
          q = function q() {
        return _(b.content);
      },
          z = function z() {
        return _(b.image);
      },
          H = function H() {
        return _(b["progress-steps"]);
      },
          V = function V() {
        return _(b["validation-message"]);
      },
          I = function I() {
        return T("." + b.actions + " ." + b.confirm);
      },
          N = function N() {
        return T("." + b.actions + " ." + b.cancel);
      },
          $ = function $() {
        return _(b.actions);
      },
          K = function K() {
        return _(b.header);
      },
          U = function U() {
        return _(b.footer);
      },
          D = function D() {
        return _(b.close);
      },
          Y = function Y() {
        var t = c(L().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])')).sort(function (t, e) {
          return t = parseInt(t.getAttribute("tabindex")), e = parseInt(e.getAttribute("tabindex")), t > e ? 1 : t < e ? -1 : 0;
        }),
            e = c(L().querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls]')).filter(function (t) {
          return "-1" !== t.getAttribute("tabindex");
        });
        return function (t) {
          for (var e = [], n = 0; n < t.length; n++) {
            -1 === e.indexOf(t[n]) && e.push(t[n]);
          }

          return e;
        }(t.concat(e)).filter(function (t) {
          return j(t);
        });
      },
          Z = function Z() {
        return !W() && !document.body.classList.contains(b["no-backdrop"]);
      },
          W = function W() {
        return document.body.classList.contains(b["toast-shown"]);
      },
          X = function X() {
        return "undefined" == typeof window || "undefined" == typeof document;
      },
          F = '\n <div aria-labelledby="'.concat(b.title, '" aria-describedby="').concat(b.content, '" class="').concat(b.popup, '" tabindex="-1">\n   <div class="').concat(b.header, '">\n     <ul class="').concat(b["progress-steps"], '"></ul>\n     <div class="').concat(b.icon, " ").concat(y.error, '">\n       <span class="swal2-x-mark"><span class="swal2-x-mark-line-left"></span><span class="swal2-x-mark-line-right"></span></span>\n     </div>\n     <div class="').concat(b.icon, " ").concat(y.question, '"></div>\n     <div class="').concat(b.icon, " ").concat(y.warning, '"></div>\n     <div class="').concat(b.icon, " ").concat(y.info, '"></div>\n     <div class="').concat(b.icon, " ").concat(y.success, '">\n       <div class="swal2-success-circular-line-left"></div>\n       <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n       <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n       <div class="swal2-success-circular-line-right"></div>\n     </div>\n     <img class="').concat(b.image, '" />\n     <h2 class="').concat(b.title, '" id="').concat(b.title, '"></h2>\n     <button type="button" class="').concat(b.close, '">&times;</button>\n   </div>\n   <div class="').concat(b.content, '">\n     <div id="').concat(b.content, '"></div>\n     <input class="').concat(b.input, '" />\n     <input type="file" class="').concat(b.file, '" />\n     <div class="').concat(b.range, '">\n       <input type="range" />\n       <output></output>\n     </div>\n     <select class="').concat(b.select, '"></select>\n     <div class="').concat(b.radio, '"></div>\n     <label for="').concat(b.checkbox, '" class="').concat(b.checkbox, '">\n       <input type="checkbox" />\n       <span class="').concat(b.label, '"></span>\n     </label>\n     <textarea class="').concat(b.textarea, '"></textarea>\n     <div class="').concat(b["validation-message"], '" id="').concat(b["validation-message"], '"></div>\n   </div>\n   <div class="').concat(b.actions, '">\n     <button type="button" class="').concat(b.confirm, '">OK</button>\n     <button type="button" class="').concat(b.cancel, '">Cancel</button>\n   </div>\n   <div class="').concat(b.footer, '">\n   </div>\n </div>\n').replace(/(^|\n)\s*/g, ""),
          Q = function Q(t) {
        var e = A();

        if (e && (e.parentNode.removeChild(e), S([document.documentElement, document.body], [b["no-backdrop"], b["toast-shown"], b["has-column"]])), !X()) {
          var n = document.createElement("div");
          n.className = b.container, n.innerHTML = F;
          var o = "string" == typeof t.target ? document.querySelector(t.target) : t.target;
          o.appendChild(n);
          var a,
              r = L(),
              s = q(),
              i = P(s, b.input),
              l = P(s, b.file),
              c = s.querySelector(".".concat(b.range, " input")),
              u = s.querySelector(".".concat(b.range, " output")),
              p = P(s, b.select),
              f = s.querySelector(".".concat(b.checkbox, " input")),
              m = P(s, b.textarea);
          r.setAttribute("role", t.toast ? "alert" : "dialog"), r.setAttribute("aria-live", t.toast ? "polite" : "assertive"), t.toast || r.setAttribute("aria-modal", "true"), "rtl" === window.getComputedStyle(o).direction && O(A(), b.rtl);

          var w = function w(t) {
            Rt.isVisible() && a !== t.target.value && Rt.resetValidationMessage(), a = t.target.value;
          };

          return i.oninput = w, l.onchange = w, p.onchange = w, f.onchange = w, m.oninput = w, c.oninput = function (t) {
            w(t), u.value = c.value;
          }, c.onchange = function (t) {
            w(t), c.nextSibling.value = c.value;
          }, r;
        }

        d("SweetAlert2 requires document to initialize");
      },
          G = function G(e, n) {
        if (!e) return E(n);
        if (e instanceof HTMLElement) n.appendChild(e);else if ("object" === t(e)) {
          if (n.innerHTML = "", 0 in e) for (var o = 0; o in e; o++) {
            n.appendChild(e[o].cloneNode(!0));
          } else n.appendChild(e.cloneNode(!0));
        } else e && (n.innerHTML = e);
        B(n);
      },
          J = function () {
        if (X()) return !1;
        var t = document.createElement("div"),
            e = {
          WebkitAnimation: "webkitAnimationEnd",
          OAnimation: "oAnimationEnd oanimationend",
          animation: "animationend"
        };

        for (var n in e) {
          if (e.hasOwnProperty(n) && void 0 !== t.style[n]) return e[n];
        }

        return !1;
      }(),
          tt = function tt(t) {
        var e = $(),
            n = I(),
            o = N();

        if (t.showConfirmButton || t.showCancelButton ? B(e) : E(e), t.showCancelButton ? o.style.display = "inline-block" : E(o), t.showConfirmButton ? n.style.removeProperty("display") : E(n), n.innerHTML = t.confirmButtonText, o.innerHTML = t.cancelButtonText, n.setAttribute("aria-label", t.confirmButtonAriaLabel), o.setAttribute("aria-label", t.cancelButtonAriaLabel), n.className = b.confirm, O(n, t.confirmButtonClass), t.customClass && O(n, t.customClass.confirmButton), o.className = b.cancel, O(o, t.cancelButtonClass), t.customClass && O(o, t.customClass.cancelButton), t.buttonsStyling) {
          O([n, o], b.styled), t.confirmButtonColor && (n.style.backgroundColor = t.confirmButtonColor), t.cancelButtonColor && (o.style.backgroundColor = t.cancelButtonColor);
          var a = window.getComputedStyle(n).getPropertyValue("background-color");
          n.style.borderLeftColor = a, n.style.borderRightColor = a;
        } else S([n, o], b.styled), n.style.backgroundColor = n.style.borderLeftColor = n.style.borderRightColor = "", o.style.backgroundColor = o.style.borderLeftColor = o.style.borderRightColor = "";
      },
          et = function et(t) {
        var e = q().querySelector("#" + b.content);
        t.html ? G(t.html, e) : t.text ? (e.textContent = t.text, B(e)) : E(e);
      },
          nt = function nt(t) {
        for (var e = M(), n = 0; n < e.length; n++) {
          E(e[n]);
        }

        if (t.type) if (-1 !== Object.keys(y).indexOf(t.type)) {
          var o = Rt.getPopup().querySelector(".".concat(b.icon, ".").concat(y[t.type]));
          B(o), t.customClass && O(o, t.customClass.icon), t.animation && O(o, "swal2-animate-".concat(t.type, "-icon"));
        } else d('Unknown type! Expected "success", "error", "warning", "info" or "question", got "'.concat(t.type, '"'));
      },
          ot = function ot(t) {
        var e = z();
        t.imageUrl ? (e.setAttribute("src", t.imageUrl), e.setAttribute("alt", t.imageAlt), B(e), t.imageWidth ? e.setAttribute("width", t.imageWidth) : e.removeAttribute("width"), t.imageHeight ? e.setAttribute("height", t.imageHeight) : e.removeAttribute("height"), e.className = b.image, t.imageClass && O(e, t.imageClass), t.customClass && O(e, t.customClass.image)) : E(e);
      },
          at = function at(t) {
        var e = H(),
            n = parseInt(null === t.currentProgressStep ? Rt.getQueueStep() : t.currentProgressStep, 10);
        t.progressSteps && t.progressSteps.length ? (B(e), e.innerHTML = "", n >= t.progressSteps.length && p("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), t.progressSteps.forEach(function (o, a) {
          var r = document.createElement("li");

          if (O(r, b["progress-step"]), r.innerHTML = o, a === n && O(r, b["active-progress-step"]), e.appendChild(r), a !== t.progressSteps.length - 1) {
            var s = document.createElement("li");
            O(s, b["progress-step-line"]), t.progressStepsDistance && (s.style.width = t.progressStepsDistance), e.appendChild(s);
          }
        })) : E(e);
      },
          rt = function rt(t) {
        var e = R();
        t.titleText ? e.innerText = t.titleText : t.title && ("string" == typeof t.title && (t.title = t.title.split("\n").join("<br />")), G(t.title, e));
      },
          st = [],
          it = function it() {
        var t = L();
        t || Rt.fire(""), t = L();
        var e = $(),
            n = I(),
            o = N();
        B(e), B(n), O([t, e], b.loading), n.disabled = !0, o.disabled = !0, t.setAttribute("data-loading", !0), t.setAttribute("aria-busy", !0), t.focus();
      },
          lt = {},
          ct = function ct() {
        return new Promise(function (t) {
          var e = window.scrollX,
              n = window.scrollY;
          lt.restoreFocusTimeout = setTimeout(function () {
            lt.previousActiveElement && lt.previousActiveElement.focus ? (lt.previousActiveElement.focus(), lt.previousActiveElement = null) : document.body && document.body.focus(), t();
          }, 100), void 0 !== e && void 0 !== n && window.scrollTo(e, n);
        });
      },
          ut = {
        title: "",
        titleText: "",
        text: "",
        html: "",
        footer: "",
        type: null,
        toast: !1,
        customClass: "",
        customContainerClass: "",
        target: "body",
        backdrop: !0,
        animation: !0,
        heightAuto: !0,
        allowOutsideClick: !0,
        allowEscapeKey: !0,
        allowEnterKey: !0,
        stopKeydownPropagation: !0,
        keydownListenerCapture: !1,
        showConfirmButton: !0,
        showCancelButton: !1,
        preConfirm: null,
        confirmButtonText: "OK",
        confirmButtonAriaLabel: "",
        confirmButtonColor: null,
        confirmButtonClass: "",
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "",
        cancelButtonColor: null,
        cancelButtonClass: "",
        buttonsStyling: !0,
        reverseButtons: !1,
        focusConfirm: !0,
        focusCancel: !1,
        showCloseButton: !1,
        closeButtonAriaLabel: "Close this dialog",
        showLoaderOnConfirm: !1,
        imageUrl: null,
        imageWidth: null,
        imageHeight: null,
        imageAlt: "",
        imageClass: "",
        timer: null,
        width: null,
        padding: null,
        background: null,
        input: null,
        inputPlaceholder: "",
        inputValue: "",
        inputOptions: {},
        inputAutoTrim: !0,
        inputClass: "",
        inputAttributes: {},
        inputValidator: null,
        validationMessage: null,
        grow: !1,
        position: "center",
        progressSteps: [],
        currentProgressStep: null,
        progressStepsDistance: null,
        onBeforeOpen: null,
        onAfterClose: null,
        onOpen: null,
        onClose: null,
        scrollbarPadding: !0
      },
          pt = {
        customContainerClass: "customClass",
        confirmButtonClass: "customClass",
        cancelButtonClass: "customClass",
        imageClass: "customClass",
        inputClass: "customClass"
      },
          dt = ["allowOutsideClick", "allowEnterKey", "backdrop", "focusConfirm", "focusCancel", "heightAuto", "keydownListenerCapture"],
          ft = function ft(t) {
        return ut.hasOwnProperty(t);
      },
          mt = function mt(t) {
        return pt[t];
      },
          wt = function wt(t) {
        for (var e in t) {
          ft(e) || p('Unknown parameter "'.concat(e, '"')), t.toast && -1 !== dt.indexOf(e) && p('The parameter "'.concat(e, '" is incompatible with toasts')), mt(e) && (n = 'The parameter "'.concat(e, '" is deprecated and will be removed in the next major release. Please use "').concat(mt(e), '" instead.'), -1 === f.indexOf(n) && (f.push(n), p(n)));
        }

        var n;
      },
          ht = Object.freeze({
        isValidParameter: ft,
        isUpdatableParameter: function isUpdatableParameter(t) {
          return -1 !== ["title", "titleText", "text", "html", "type", "showConfirmButton", "showCancelButton", "confirmButtonText", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonClass", "cancelButtonText", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonClass", "buttonsStyling", "reverseButtons", "imageUrl", "imageWidth", "imageHeigth", "imageAlt", "imageClass", "progressSteps", "currentProgressStep"].indexOf(t);
        },
        isDeprecatedParameter: mt,
        argsToParams: function argsToParams(e) {
          var n = {};

          switch (t(e[0])) {
            case "object":
              o(n, e[0]);
              break;

            default:
              ["title", "html", "type"].forEach(function (o, a) {
                switch (t(e[a])) {
                  case "string":
                    n[o] = e[a];
                    break;

                  case "undefined":
                    break;

                  default:
                    d("Unexpected type of ".concat(o, '! Expected "string", got ').concat(t(e[a])));
                }
              });
          }

          return n;
        },
        isVisible: function isVisible() {
          return j(L());
        },
        clickConfirm: function clickConfirm() {
          return I() && I().click();
        },
        clickCancel: function clickCancel() {
          return N() && N().click();
        },
        getContainer: A,
        getPopup: L,
        getTitle: R,
        getContent: q,
        getImage: z,
        getIcon: function getIcon() {
          var t = M().filter(function (t) {
            return j(t);
          });
          return t.length ? t[0] : null;
        },
        getIcons: M,
        getCloseButton: D,
        getActions: $,
        getConfirmButton: I,
        getCancelButton: N,
        getHeader: K,
        getFooter: U,
        getFocusableElements: Y,
        getValidationMessage: V,
        isLoading: function isLoading() {
          return L().hasAttribute("data-loading");
        },
        fire: function fire() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
            e[n] = arguments[n];
          }

          return s(this, e);
        },
        mixin: function mixin(t) {
          return function (s) {
            function c() {
              return e(this, c), i(this, a(c).apply(this, arguments));
            }

            return function (t, e) {
              if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
              t.prototype = Object.create(e && e.prototype, {
                constructor: {
                  value: t,
                  writable: !0,
                  configurable: !0
                }
              }), e && r(t, e);
            }(c, s), u = c, (p = [{
              key: "_main",
              value: function value(e) {
                return l(a(c.prototype), "_main", this).call(this, o({}, t, e));
              }
            }]) && n(u.prototype, p), d && n(u, d), c;
            var u, p, d;
          }(this);
        },
        queue: function queue(t) {
          var e = this;
          st = t;

          var n = function n() {
            st = [], document.body.removeAttribute("data-swal2-queue-step");
          },
              o = [];

          return new Promise(function (t) {
            !function a(r, s) {
              r < st.length ? (document.body.setAttribute("data-swal2-queue-step", r), e.fire(st[r]).then(function (e) {
                void 0 !== e.value ? (o.push(e.value), a(r + 1, s)) : (n(), t({
                  dismiss: e.dismiss
                }));
              })) : (n(), t({
                value: o
              }));
            }(0);
          });
        },
        getQueueStep: function getQueueStep() {
          return document.body.getAttribute("data-swal2-queue-step");
        },
        insertQueueStep: function insertQueueStep(t, e) {
          return e && e < st.length ? st.splice(e, 0, t) : st.push(t);
        },
        deleteQueueStep: function deleteQueueStep(t) {
          void 0 !== st[t] && st.splice(t, 1);
        },
        showLoading: it,
        enableLoading: it,
        getTimerLeft: function getTimerLeft() {
          return lt.timeout && lt.timeout.getTimerLeft();
        },
        stopTimer: function stopTimer() {
          return lt.timeout && lt.timeout.stop();
        },
        resumeTimer: function resumeTimer() {
          return lt.timeout && lt.timeout.start();
        },
        toggleTimer: function toggleTimer() {
          var t = lt.timeout;
          return t && (t.running ? t.stop() : t.start());
        },
        increaseTimer: function increaseTimer(t) {
          return lt.timeout && lt.timeout.increase(t);
        },
        isTimerRunning: function isTimerRunning() {
          return lt.timeout && lt.timeout.isRunning();
        }
      }),
          gt = {
        promise: new WeakMap(),
        innerParams: new WeakMap(),
        domCache: new WeakMap()
      };

      function bt() {
        var t = gt.innerParams.get(this),
            e = gt.domCache.get(this);
        t.showConfirmButton || (E(e.confirmButton), t.showCancelButton || E(e.actions)), S([e.popup, e.actions], b.loading), e.popup.removeAttribute("aria-busy"), e.popup.removeAttribute("data-loading"), e.confirmButton.disabled = !1, e.cancelButton.disabled = !1;
      }

      var yt = function yt() {
        null === v.previousBodyPadding && document.body.scrollHeight > window.innerHeight && (v.previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = v.previousBodyPadding + function () {
          if ("ontouchstart" in window || navigator.msMaxTouchPoints) return 0;
          var t = document.createElement("div");
          t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t);
          var e = t.offsetWidth - t.clientWidth;
          return document.body.removeChild(t), e;
        }() + "px");
      },
          vt = function vt() {
        null !== v.previousBodyPadding && (document.body.style.paddingRight = v.previousBodyPadding + "px", v.previousBodyPadding = null);
      },
          kt = function kt() {
        if (k(document.body, b.iosfix)) {
          var t = parseInt(document.body.style.top, 10);
          S(document.body, b.iosfix), document.body.style.top = "", document.body.scrollTop = -1 * t;
        }
      },
          xt = function xt() {
        return !!window.MSInputMethodContext && !!document.documentMode;
      },
          Ct = function Ct() {
        var t = A(),
            e = L();
        t.style.removeProperty("align-items"), e.offsetTop < 0 && (t.style.alignItems = "flex-start");
      },
          Ot = function Ot() {
        "undefined" != typeof window && xt() && window.removeEventListener("resize", Ct);
      },
          St = function St() {
        var t = c(document.body.children);
        t.forEach(function (t) {
          t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden")), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
        });
      },
          Pt = {
        swalPromiseResolve: new WeakMap()
      };

      function Bt(t) {
        var e = A(),
            n = L(),
            o = gt.innerParams.get(this),
            a = Pt.swalPromiseResolve.get(this),
            r = o.onClose,
            s = o.onAfterClose;

        if (n) {
          null !== r && "function" == typeof r && r(n), S(n, b.show), O(n, b.hide);

          var i = function i() {
            W() ? jt(s) : (ct().then(function () {
              return jt(s);
            }), lt.keydownTarget.removeEventListener("keydown", lt.keydownHandler, {
              capture: lt.keydownListenerCapture
            }), lt.keydownHandlerAdded = !1), e.parentNode && e.parentNode.removeChild(e), S([document.documentElement, document.body], [b.shown, b["height-auto"], b["no-backdrop"], b["toast-shown"], b["toast-column"]]), Z() && (vt(), kt(), Ot(), St());
          };

          J && !k(n, b.noanimation) ? n.addEventListener(J, function t() {
            n.removeEventListener(J, t), k(n, b.hide) && i();
          }) : i(), a(t || {});
        }
      }

      var Et,
          jt = function jt(t) {
        null !== t && "function" == typeof t && setTimeout(function () {
          t();
        });
      },
          At = function t(n, o) {
        e(this, t);
        var a,
            r,
            s = o;
        this.running = !1, this.start = function () {
          return this.running || (this.running = !0, r = new Date(), a = setTimeout(n, s)), s;
        }, this.stop = function () {
          return this.running && (this.running = !1, clearTimeout(a), s -= new Date() - r), s;
        }, this.increase = function (t) {
          var e = this.running;
          return e && this.stop(), s += t, e && this.start(), s;
        }, this.getTimerLeft = function () {
          return this.running && (this.stop(), this.start()), s;
        }, this.isRunning = function () {
          return this.running;
        }, this.start();
      },
          Tt = {
        email: function email(t, e) {
          return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(t) ? Promise.resolve() : Promise.resolve(e || "Invalid email address");
        },
        url: function url(t, e) {
          return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&\/\/=]*)$/.test(t) ? Promise.resolve() : Promise.resolve(e || "Invalid URL");
        }
      },
          _t = function _t(t) {
        var e = A(),
            n = L();
        null !== t.onBeforeOpen && "function" == typeof t.onBeforeOpen && t.onBeforeOpen(n), t.animation ? (O(n, b.show), O(e, b.fade), S(n, b.hide)) : S(n, b.fade), B(n), e.style.overflowY = "hidden", J && !k(n, b.noanimation) ? n.addEventListener(J, function t() {
          n.removeEventListener(J, t), e.style.overflowY = "auto";
        }) : e.style.overflowY = "auto", O([document.documentElement, document.body, e], b.shown), t.heightAuto && t.backdrop && !t.toast && O([document.documentElement, document.body], b["height-auto"]), Z() && (t.scrollbarPadding && yt(), function () {
          if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && !k(document.body, b.iosfix)) {
            var t = document.body.scrollTop;
            document.body.style.top = -1 * t + "px", O(document.body, b.iosfix);
          }
        }(), "undefined" != typeof window && xt() && (Ct(), window.addEventListener("resize", Ct)), c(document.body.children).forEach(function (t) {
          t === A() || function (t, e) {
            if ("function" == typeof t.contains) return t.contains(e);
          }(t, A()) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden")), t.setAttribute("aria-hidden", "true"));
        }), setTimeout(function () {
          e.scrollTop = 0;
        })), W() || lt.previousActiveElement || (lt.previousActiveElement = document.activeElement), null !== t.onOpen && "function" == typeof t.onOpen && setTimeout(function () {
          t.onOpen(n);
        });
      },
          Lt = Object.freeze({
        hideLoading: bt,
        disableLoading: bt,
        getInput: function getInput(t) {
          var e = gt.innerParams.get(this),
              n = gt.domCache.get(this);
          if (!(t = t || e.input)) return null;

          switch (t) {
            case "select":
            case "textarea":
            case "file":
              return P(n.content, b[t]);

            case "checkbox":
              return n.popup.querySelector(".".concat(b.checkbox, " input"));

            case "radio":
              return n.popup.querySelector(".".concat(b.radio, " input:checked")) || n.popup.querySelector(".".concat(b.radio, " input:first-child"));

            case "range":
              return n.popup.querySelector(".".concat(b.range, " input"));

            default:
              return P(n.content, b.input);
          }
        },
        close: Bt,
        closePopup: Bt,
        closeModal: Bt,
        closeToast: Bt,
        enableButtons: function enableButtons() {
          var t = gt.domCache.get(this);
          t.confirmButton.disabled = !1, t.cancelButton.disabled = !1;
        },
        disableButtons: function disableButtons() {
          var t = gt.domCache.get(this);
          t.confirmButton.disabled = !0, t.cancelButton.disabled = !0;
        },
        enableConfirmButton: function enableConfirmButton() {
          gt.domCache.get(this).confirmButton.disabled = !1;
        },
        disableConfirmButton: function disableConfirmButton() {
          gt.domCache.get(this).confirmButton.disabled = !0;
        },
        enableInput: function enableInput() {
          var t = this.getInput();
          if (!t) return !1;
          if ("radio" === t.type) for (var e = t.parentNode.parentNode, n = e.querySelectorAll("input"), o = 0; o < n.length; o++) {
            n[o].disabled = !1;
          } else t.disabled = !1;
        },
        disableInput: function disableInput() {
          var t = this.getInput();
          if (!t) return !1;
          if (t && "radio" === t.type) for (var e = t.parentNode.parentNode, n = e.querySelectorAll("input"), o = 0; o < n.length; o++) {
            n[o].disabled = !0;
          } else t.disabled = !0;
        },
        showValidationMessage: function showValidationMessage(t) {
          var e = gt.domCache.get(this);
          e.validationMessage.innerHTML = t;
          var n = window.getComputedStyle(e.popup);
          e.validationMessage.style.marginLeft = "-".concat(n.getPropertyValue("padding-left")), e.validationMessage.style.marginRight = "-".concat(n.getPropertyValue("padding-right")), B(e.validationMessage);
          var o = this.getInput();
          o && (o.setAttribute("aria-invalid", !0), o.setAttribute("aria-describedBy", b["validation-message"]), x(o), O(o, b.inputerror));
        },
        resetValidationMessage: function resetValidationMessage() {
          var t = gt.domCache.get(this);
          t.validationMessage && E(t.validationMessage);
          var e = this.getInput();
          e && (e.removeAttribute("aria-invalid"), e.removeAttribute("aria-describedBy"), S(e, b.inputerror));
        },
        getProgressSteps: function getProgressSteps() {
          return gt.innerParams.get(this).progressSteps;
        },
        setProgressSteps: function setProgressSteps(t) {
          var e = o({}, gt.innerParams.get(this), {
            progressSteps: t
          });
          gt.innerParams.set(this, e), at(e);
        },
        showProgressSteps: function showProgressSteps() {
          var t = gt.domCache.get(this);
          B(t.progressSteps);
        },
        hideProgressSteps: function hideProgressSteps() {
          var t = gt.domCache.get(this);
          E(t.progressSteps);
        },
        _main: function _main(e) {
          var n = this;
          wt(e);
          var a = o({}, ut, e);
          (function (t) {
            t.inputValidator || Object.keys(Tt).forEach(function (e) {
              t.input === e && (t.inputValidator = Tt[e]);
            }), (!t.target || "string" == typeof t.target && !document.querySelector(t.target) || "string" != typeof t.target && !t.target.appendChild) && (p('Target parameter is not valid, defaulting to "body"'), t.target = "body"), "function" == typeof t.animation && (t.animation = t.animation.call());
            var e,
                n = L(),
                o = "string" == typeof t.target ? document.querySelector(t.target) : t.target;
            e = n && o && n.parentNode !== o.parentNode ? Q(t) : n || Q(t), t.width && (e.style.width = "number" == typeof t.width ? t.width + "px" : t.width), null !== t.padding && (e.style.padding = "number" == typeof t.padding ? t.padding + "px" : t.padding), t.background && (e.style.background = t.background);

            for (var a = window.getComputedStyle(e).getPropertyValue("background-color"), r = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix"), s = 0; s < r.length; s++) {
              r[s].style.backgroundColor = a;
            }

            var i = A(),
                l = D(),
                c = K(),
                u = R(),
                d = q(),
                f = $(),
                m = U();

            if (rt(t), et(t), "string" == typeof t.backdrop ? A().style.background = t.backdrop : t.backdrop || O([document.documentElement, document.body], b["no-backdrop"]), !t.backdrop && t.allowOutsideClick && p('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), t.position in b ? O(i, b[t.position]) : (p('The "position" parameter is not valid, defaulting to "center"'), O(i, b.center)), t.grow && "string" == typeof t.grow) {
              var w = "grow-" + t.grow;
              w in b && O(i, b[w]);
            }

            t.showCloseButton ? (l.setAttribute("aria-label", t.closeButtonAriaLabel), B(l)) : E(l), e.className = b.popup, t.toast ? (O([document.documentElement, document.body], b["toast-shown"]), O(e, b.toast)) : O(e, b.modal), t.customClass && (O(i, t.customClass.container), O(e, "string" == typeof t.customClass ? t.customClass : t.customClass.popup), O(c, t.customClass.header), O(u, t.customClass.title), O(l, t.customClass.closeButton), O(d, t.customClass.content), O(f, t.customClass.actions), O(m, t.customClass.footer)), t.customContainerClass && O(i, t.customContainerClass), at(t), nt(t), ot(t), tt(t), G(t.footer, m), !0 === t.animation ? S(e, b.noanimation) : O(e, b.noanimation), t.showLoaderOnConfirm && !t.preConfirm && p("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
          })(a), Object.freeze(a), gt.innerParams.set(this, a), lt.timeout && (lt.timeout.stop(), delete lt.timeout), clearTimeout(lt.restoreFocusTimeout);
          var r = {
            popup: L(),
            container: A(),
            content: q(),
            actions: $(),
            confirmButton: I(),
            cancelButton: N(),
            closeButton: D(),
            validationMessage: V(),
            progressSteps: H()
          };
          gt.domCache.set(this, r);
          var s = this.constructor;
          return new Promise(function (e) {
            var o = function o(t) {
              n.closePopup({
                value: t
              });
            },
                i = function i(t) {
              n.closePopup({
                dismiss: t
              });
            };

            Pt.swalPromiseResolve.set(n, e), a.timer && (lt.timeout = new At(function () {
              i("timer"), delete lt.timeout;
            }, a.timer)), a.input && setTimeout(function () {
              var t = n.getInput();
              t && x(t);
            }, 0);

            for (var l = function l(t) {
              if (a.showLoaderOnConfirm && s.showLoading(), a.preConfirm) {
                n.resetValidationMessage();
                var e = Promise.resolve().then(function () {
                  return a.preConfirm(t, a.validationMessage);
                });
                e.then(function (e) {
                  j(r.validationMessage) || !1 === e ? n.hideLoading() : o(void 0 === e ? t : e);
                });
              } else o(t);
            }, c = function c(t) {
              var e = t.target,
                  o = r.confirmButton,
                  c = r.cancelButton,
                  u = o && (o === e || o.contains(e)),
                  p = c && (c === e || c.contains(e));

              switch (t.type) {
                case "click":
                  if (u) {
                    if (n.disableButtons(), a.input) {
                      var d = function () {
                        var t = n.getInput();
                        if (!t) return null;

                        switch (a.input) {
                          case "checkbox":
                            return t.checked ? 1 : 0;

                          case "radio":
                            return t.checked ? t.value : null;

                          case "file":
                            return t.files.length ? t.files[0] : null;

                          default:
                            return a.inputAutoTrim ? t.value.trim() : t.value;
                        }
                      }();

                      if (a.inputValidator) {
                        n.disableInput();
                        var f = Promise.resolve().then(function () {
                          return a.inputValidator(d, a.validationMessage);
                        });
                        f.then(function (t) {
                          n.enableButtons(), n.enableInput(), t ? n.showValidationMessage(t) : l(d);
                        });
                      } else n.getInput().checkValidity() ? l(d) : (n.enableButtons(), n.showValidationMessage(a.validationMessage));
                    } else l(!0);
                  } else p && (n.disableButtons(), i(s.DismissReason.cancel));
              }
            }, f = r.popup.querySelectorAll("button"), h = 0; h < f.length; h++) {
              f[h].onclick = c, f[h].onmouseover = c, f[h].onmouseout = c, f[h].onmousedown = c;
            }

            if (r.closeButton.onclick = function () {
              i(s.DismissReason.close);
            }, a.toast) r.popup.onclick = function () {
              a.showConfirmButton || a.showCancelButton || a.showCloseButton || a.input || i(s.DismissReason.close);
            };else {
              var g = !1;
              r.popup.onmousedown = function () {
                r.container.onmouseup = function (t) {
                  r.container.onmouseup = void 0, t.target === r.container && (g = !0);
                };
              }, r.container.onmousedown = function () {
                r.popup.onmouseup = function (t) {
                  r.popup.onmouseup = void 0, (t.target === r.popup || r.popup.contains(t.target)) && (g = !0);
                };
              }, r.container.onclick = function (t) {
                g ? g = !1 : t.target === r.container && m(a.allowOutsideClick) && i(s.DismissReason.backdrop);
              };
            }
            a.reverseButtons ? r.confirmButton.parentNode.insertBefore(r.cancelButton, r.confirmButton) : r.confirmButton.parentNode.insertBefore(r.confirmButton, r.cancelButton);

            var y = function y(t, e) {
              for (var n = Y(a.focusCancel), o = 0; o < n.length; o++) {
                return (t += e) === n.length ? t = 0 : -1 === t && (t = n.length - 1), n[t].focus();
              }

              r.popup.focus();
            };

            lt.keydownHandlerAdded && (lt.keydownTarget.removeEventListener("keydown", lt.keydownHandler, {
              capture: lt.keydownListenerCapture
            }), lt.keydownHandlerAdded = !1), a.toast || (lt.keydownHandler = function (t) {
              return function (t, e) {
                if (e.stopKeydownPropagation && t.stopPropagation(), "Enter" !== t.key || t.isComposing) {
                  if ("Tab" === t.key) {
                    for (var o = t.target, a = Y(e.focusCancel), l = -1, c = 0; c < a.length; c++) {
                      if (o === a[c]) {
                        l = c;
                        break;
                      }
                    }

                    t.shiftKey ? y(l, -1) : y(l, 1), t.stopPropagation(), t.preventDefault();
                  } else -1 !== ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Left", "Right", "Up", "Down"].indexOf(t.key) ? document.activeElement === r.confirmButton && j(r.cancelButton) ? r.cancelButton.focus() : document.activeElement === r.cancelButton && j(r.confirmButton) && r.confirmButton.focus() : "Escape" !== t.key && "Esc" !== t.key || !0 !== m(e.allowEscapeKey) || (t.preventDefault(), i(s.DismissReason.esc));
                } else if (t.target && n.getInput() && t.target.outerHTML === n.getInput().outerHTML) {
                  if (-1 !== ["textarea", "file"].indexOf(e.input)) return;
                  s.clickConfirm(), t.preventDefault();
                }
              }(t, a);
            }, lt.keydownTarget = a.keydownListenerCapture ? window : r.popup, lt.keydownListenerCapture = a.keydownListenerCapture, lt.keydownTarget.addEventListener("keydown", lt.keydownHandler, {
              capture: lt.keydownListenerCapture
            }), lt.keydownHandlerAdded = !0), n.enableButtons(), n.hideLoading(), n.resetValidationMessage(), a.toast && (a.input || a.footer || a.showCloseButton) ? O(document.body, b["toast-column"]) : S(document.body, b["toast-column"]);

            for (var v, k, C = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], A = function A(t) {
              t.placeholder && !a.inputPlaceholder || (t.placeholder = a.inputPlaceholder);
            }, T = 0; T < C.length; T++) {
              var _ = b[C[T]],
                  L = P(r.content, _);

              if (v = n.getInput(C[T])) {
                for (var M in v.attributes) {
                  if (v.attributes.hasOwnProperty(M)) {
                    var R = v.attributes[M].name;
                    "type" !== R && "value" !== R && v.removeAttribute(R);
                  }
                }

                for (var q in a.inputAttributes) {
                  "range" === C[T] && "placeholder" === q || v.setAttribute(q, a.inputAttributes[q]);
                }
              }

              L.className = _, a.inputClass && O(L, a.inputClass), a.customClass && O(L, a.customClass.input), E(L);
            }

            switch (a.input) {
              case "text":
              case "email":
              case "password":
              case "number":
              case "tel":
              case "url":
                v = P(r.content, b.input), "string" == typeof a.inputValue || "number" == typeof a.inputValue ? v.value = a.inputValue : w(a.inputValue) || p('Unexpected type of inputValue! Expected "string", "number" or "Promise", got "'.concat(t(a.inputValue), '"')), A(v), v.type = a.input, B(v);
                break;

              case "file":
                v = P(r.content, b.file), A(v), v.type = a.input, B(v);
                break;

              case "range":
                var z = P(r.content, b.range),
                    H = z.querySelector("input"),
                    V = z.querySelector("output");
                H.value = a.inputValue, H.type = a.input, V.value = a.inputValue, B(z);
                break;

              case "select":
                var I = P(r.content, b.select);

                if (I.innerHTML = "", a.inputPlaceholder) {
                  var N = document.createElement("option");
                  N.innerHTML = a.inputPlaceholder, N.value = "", N.disabled = !0, N.selected = !0, I.appendChild(N);
                }

                k = function k(t) {
                  t.forEach(function (t) {
                    var e = t[0],
                        n = t[1],
                        o = document.createElement("option");
                    o.value = e, o.innerHTML = n, a.inputValue.toString() === e.toString() && (o.selected = !0), I.appendChild(o);
                  }), B(I), I.focus();
                };

                break;

              case "radio":
                var $ = P(r.content, b.radio);
                $.innerHTML = "", k = function k(t) {
                  t.forEach(function (t) {
                    var e = t[0],
                        n = t[1],
                        o = document.createElement("input"),
                        r = document.createElement("label");
                    o.type = "radio", o.name = b.radio, o.value = e, a.inputValue.toString() === e.toString() && (o.checked = !0);
                    var s = document.createElement("span");
                    s.innerHTML = n, s.className = b.label, r.appendChild(o), r.appendChild(s), $.appendChild(r);
                  }), B($);
                  var e = $.querySelectorAll("input");
                  e.length && e[0].focus();
                };
                break;

              case "checkbox":
                var K = P(r.content, b.checkbox),
                    U = n.getInput("checkbox");
                U.type = "checkbox", U.value = 1, U.id = b.checkbox, U.checked = Boolean(a.inputValue);
                var D = K.querySelector("span");
                D.innerHTML = a.inputPlaceholder, B(K);
                break;

              case "textarea":
                var Z = P(r.content, b.textarea);
                Z.value = a.inputValue, A(Z), B(Z);
                break;

              case null:
                break;

              default:
                d('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "'.concat(a.input, '"'));
            }

            if ("select" === a.input || "radio" === a.input) {
              var W = function W(t) {
                return k(u(t));
              };

              w(a.inputOptions) ? (s.showLoading(), a.inputOptions.then(function (t) {
                n.hideLoading(), W(t);
              })) : "object" === t(a.inputOptions) ? W(a.inputOptions) : d("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(t(a.inputOptions)));
            } else -1 !== ["text", "email", "number", "tel", "textarea"].indexOf(a.input) && w(a.inputValue) && (s.showLoading(), E(v), a.inputValue.then(function (t) {
              v.value = "number" === a.input ? parseFloat(t) || 0 : t + "", B(v), v.focus(), n.hideLoading();
            }).catch(function (t) {
              d("Error in inputValue promise: " + t), v.value = "", B(v), v.focus(), n.hideLoading();
            }));

            _t(a), a.toast || (m(a.allowEnterKey) ? a.focusCancel && j(r.cancelButton) ? r.cancelButton.focus() : a.focusConfirm && j(r.confirmButton) ? r.confirmButton.focus() : y(-1, 1) : document.activeElement && "function" == typeof document.activeElement.blur && document.activeElement.blur()), r.container.scrollTop = 0;
          });
        },
        update: function update(t) {
          var e = {};
          Object.keys(t).forEach(function (n) {
            Rt.isUpdatableParameter(n) ? e[n] = t[n] : p('Invalid parameter to update: "'.concat(n, '". Updatable params are listed here: https://github.com/sweetalert2/sweetalert2/blob/master/src/utils/params.js'));
          });
          var n = o({}, gt.innerParams.get(this), e);
          tt(n), et(n), nt(n), ot(n), at(n), rt(n), gt.innerParams.set(this, n);
        }
      });

      function Mt() {
        if ("undefined" != typeof window) {
          "undefined" == typeof Promise && d("This package requires a Promise library, please include a shim to enable it in this browser (See: https://github.com/sweetalert2/sweetalert2/wiki/Migration-from-SweetAlert-to-SweetAlert2#1-ie-support)"), Et = this;

          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
            e[n] = arguments[n];
          }

          var o = Object.freeze(this.constructor.argsToParams(e));
          Object.defineProperties(this, {
            params: {
              value: o,
              writable: !1,
              enumerable: !0
            }
          });

          var a = this._main(this.params);

          gt.promise.set(this, a);
        }
      }

      Mt.prototype.then = function (t) {
        var e = gt.promise.get(this);
        return e.then(t);
      }, Mt.prototype.finally = function (t) {
        var e = gt.promise.get(this);
        return e.finally(t);
      }, o(Mt.prototype, Lt), o(Mt, ht), Object.keys(Lt).forEach(function (t) {
        Mt[t] = function () {
          var e;
          if (Et) return (e = Et)[t].apply(e, arguments);
        };
      }), Mt.DismissReason = h, Mt.version = "8.5.0";
      var Rt = Mt;
      return Rt.default = Rt, Rt;
    }(), "undefined" != typeof window && window.Sweetalert2 && (window.swal = window.sweetAlert = window.Swal = window.SweetAlert = window.Sweetalert2), "undefined" != typeof document && function (t, e) {
      var n = t.createElement("style");
      if (t.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = e);else try {
        n.innerHTML = e;
      } catch (t) {
        n.innerText = e;
      }
    }(document, "@charset \"UTF-8\";@-webkit-keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}100%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes swal2-show{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}100%{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}100%{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes swal2-hide{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}100%{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@-webkit-keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.875em;width:1.5625em}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.875em;width:1.5625em}}@-webkit-keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@-webkit-keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}100%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes swal2-rotate-success-circular-line{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}100%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}100%{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}50%{margin-top:1.625em;-webkit-transform:scale(.4);transform:scale(.4);opacity:0}80%{margin-top:-.375em;-webkit-transform:scale(1.15);transform:scale(1.15)}100%{margin-top:0;-webkit-transform:scale(1);transform:scale(1);opacity:1}}@-webkit-keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}100%{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}@keyframes swal2-animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}100%{-webkit-transform:rotateX(0);transform:rotateX(0);opacity:1}}body.swal2-toast-shown .swal2-container{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-shown{background-color:transparent}body.swal2-toast-shown .swal2-container.swal2-top{top:0;right:auto;bottom:auto;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{top:0;right:0;bottom:auto;left:auto}body.swal2-toast-shown .swal2-container.swal2-top-left,body.swal2-toast-shown .swal2-container.swal2-top-start{top:0;right:auto;bottom:auto;left:0}body.swal2-toast-shown .swal2-container.swal2-center-left,body.swal2-toast-shown .swal2-container.swal2-center-start{top:50%;right:auto;bottom:auto;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{top:50%;right:auto;bottom:auto;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{top:50%;right:0;bottom:auto;left:auto;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-left,body.swal2-toast-shown .swal2-container.swal2-bottom-start{top:auto;right:auto;bottom:0;left:0}body.swal2-toast-shown .swal2-container.swal2-bottom{top:auto;right:auto;bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{top:auto;right:0;bottom:0;left:auto}body.swal2-toast-column .swal2-toast{flex-direction:column;align-items:stretch}body.swal2-toast-column .swal2-toast .swal2-actions{flex:1;align-self:stretch;height:2.2em;margin-top:.3125em}body.swal2-toast-column .swal2-toast .swal2-loading{justify-content:center}body.swal2-toast-column .swal2-toast .swal2-input{height:2em;margin:.3125em auto;font-size:1em}body.swal2-toast-column .swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast{flex-direction:row;align-items:center;width:auto;padding:.625em;box-shadow:0 0 .625em #d9d9d9;overflow-y:hidden}.swal2-popup.swal2-toast .swal2-header{flex-direction:row}.swal2-popup.swal2-toast .swal2-title{flex-grow:1;justify-content:flex-start;margin:0 .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{position:initial;width:.8em;height:.8em;line-height:.8}.swal2-popup.swal2-toast .swal2-content{justify-content:flex-start;font-size:1em}.swal2-popup.swal2-toast .swal2-icon{width:2em;min-width:2em;height:2em;margin:0}.swal2-popup.swal2-toast .swal2-icon::before{display:flex;align-items:center;font-size:2em;font-weight:700}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-popup.swal2-toast .swal2-icon::before{font-size:.25em}}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{height:auto;margin:0 .3125em}.swal2-popup.swal2-toast .swal2-styled{margin:0 .3125em;padding:.3125em .625em;font-size:1em}.swal2-popup.swal2-toast .swal2-styled:focus{box-shadow:0 0 0 .0625em #fff,0 0 0 .125em rgba(50,100,150,.4)}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:2em;height:2.8125em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.25em;left:-.9375em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:2em 2em;transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.25em;left:.9375em;-webkit-transform-origin:0 2em;transform-origin:0 2em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast.swal2-show{-webkit-animation:showSweetToast .5s;animation:showSweetToast .5s}.swal2-popup.swal2-toast.swal2-hide{-webkit-animation:hideSweetToast .2s forwards;animation:hideSweetToast .2s forwards}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation:animate-toast-success-tip .75s;animation:animate-toast-success-tip .75s}.swal2-popup.swal2-toast .swal2-animate-success-icon .swal2-success-line-long{-webkit-animation:animate-toast-success-long .75s;animation:animate-toast-success-long .75s}@-webkit-keyframes showSweetToast{0%{-webkit-transform:translateY(-.625em) rotateZ(2deg);transform:translateY(-.625em) rotateZ(2deg);opacity:0}33%{-webkit-transform:translateY(0) rotateZ(-2deg);transform:translateY(0) rotateZ(-2deg);opacity:.5}66%{-webkit-transform:translateY(.3125em) rotateZ(2deg);transform:translateY(.3125em) rotateZ(2deg);opacity:.7}100%{-webkit-transform:translateY(0) rotateZ(0);transform:translateY(0) rotateZ(0);opacity:1}}@keyframes showSweetToast{0%{-webkit-transform:translateY(-.625em) rotateZ(2deg);transform:translateY(-.625em) rotateZ(2deg);opacity:0}33%{-webkit-transform:translateY(0) rotateZ(-2deg);transform:translateY(0) rotateZ(-2deg);opacity:.5}66%{-webkit-transform:translateY(.3125em) rotateZ(2deg);transform:translateY(.3125em) rotateZ(2deg);opacity:.7}100%{-webkit-transform:translateY(0) rotateZ(0);transform:translateY(0) rotateZ(0);opacity:1}}@-webkit-keyframes hideSweetToast{0%{opacity:1}33%{opacity:.5}100%{-webkit-transform:rotateZ(1deg);transform:rotateZ(1deg);opacity:0}}@keyframes hideSweetToast{0%{opacity:1}33%{opacity:.5}100%{-webkit-transform:rotateZ(1deg);transform:rotateZ(1deg);opacity:0}}@-webkit-keyframes animate-toast-success-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes animate-toast-success-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@-webkit-keyframes animate-toast-success-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes animate-toast-success-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto!important}body.swal2-no-backdrop .swal2-shown{top:auto;right:auto;bottom:auto;left:auto;background-color:transparent}body.swal2-no-backdrop .swal2-shown>.swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}body.swal2-no-backdrop .swal2-shown.swal2-top{top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-top-left,body.swal2-no-backdrop .swal2-shown.swal2-top-start{top:0;left:0}body.swal2-no-backdrop .swal2-shown.swal2-top-end,body.swal2-no-backdrop .swal2-shown.swal2-top-right{top:0;right:0}body.swal2-no-backdrop .swal2-shown.swal2-center{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body.swal2-no-backdrop .swal2-shown.swal2-center-left,body.swal2-no-backdrop .swal2-shown.swal2-center-start{top:50%;left:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-center-end,body.swal2-no-backdrop .swal2-shown.swal2-center-right{top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-bottom{bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}body.swal2-no-backdrop .swal2-shown.swal2-bottom-left,body.swal2-no-backdrop .swal2-shown.swal2-bottom-start{bottom:0;left:0}body.swal2-no-backdrop .swal2-shown.swal2-bottom-end,body.swal2-no-backdrop .swal2-shown.swal2-bottom-right{right:0;bottom:0}.swal2-container{display:flex;position:fixed;top:0;right:0;bottom:0;left:0;flex-direction:row;align-items:center;justify-content:center;padding:10px;background-color:transparent;z-index:1060;overflow-x:hidden;-webkit-overflow-scrolling:touch}.swal2-container.swal2-top{align-items:flex-start}.swal2-container.swal2-top-left,.swal2-container.swal2-top-start{align-items:flex-start;justify-content:flex-start}.swal2-container.swal2-top-end,.swal2-container.swal2-top-right{align-items:flex-start;justify-content:flex-end}.swal2-container.swal2-center{align-items:center}.swal2-container.swal2-center-left,.swal2-container.swal2-center-start{align-items:center;justify-content:flex-start}.swal2-container.swal2-center-end,.swal2-container.swal2-center-right{align-items:center;justify-content:flex-end}.swal2-container.swal2-bottom{align-items:flex-end}.swal2-container.swal2-bottom-left,.swal2-container.swal2-bottom-start{align-items:flex-end;justify-content:flex-start}.swal2-container.swal2-bottom-end,.swal2-container.swal2-bottom-right{align-items:flex-end;justify-content:flex-end}.swal2-container.swal2-bottom-end>:first-child,.swal2-container.swal2-bottom-left>:first-child,.swal2-container.swal2-bottom-right>:first-child,.swal2-container.swal2-bottom-start>:first-child,.swal2-container.swal2-bottom>:first-child{margin-top:auto}.swal2-container.swal2-grow-fullscreen>.swal2-modal{display:flex!important;flex:1;align-self:stretch;justify-content:center}.swal2-container.swal2-grow-row>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container.swal2-grow-column{flex:1;flex-direction:column}.swal2-container.swal2-grow-column.swal2-bottom,.swal2-container.swal2-grow-column.swal2-center,.swal2-container.swal2-grow-column.swal2-top{align-items:center}.swal2-container.swal2-grow-column.swal2-bottom-left,.swal2-container.swal2-grow-column.swal2-bottom-start,.swal2-container.swal2-grow-column.swal2-center-left,.swal2-container.swal2-grow-column.swal2-center-start,.swal2-container.swal2-grow-column.swal2-top-left,.swal2-container.swal2-grow-column.swal2-top-start{align-items:flex-start}.swal2-container.swal2-grow-column.swal2-bottom-end,.swal2-container.swal2-grow-column.swal2-bottom-right,.swal2-container.swal2-grow-column.swal2-center-end,.swal2-container.swal2-grow-column.swal2-center-right,.swal2-container.swal2-grow-column.swal2-top-end,.swal2-container.swal2-grow-column.swal2-top-right{align-items:flex-end}.swal2-container.swal2-grow-column>.swal2-modal{display:flex!important;flex:1;align-content:center;justify-content:center}.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen)>.swal2-modal{margin:auto}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-container .swal2-modal{margin:0!important}}.swal2-container.swal2-fade{transition:background-color .1s}.swal2-container.swal2-shown{background-color:rgba(0,0,0,.4)}.swal2-popup{display:none;position:relative;flex-direction:column;justify-content:center;width:32em;max-width:100%;padding:1.25em;border-radius:.3125em;background:#fff;font-family:inherit;font-size:1rem;box-sizing:border-box}.swal2-popup:focus{outline:0}.swal2-popup.swal2-loading{overflow-y:hidden}.swal2-popup .swal2-header{display:flex;flex-direction:column;align-items:center}.swal2-popup .swal2-title{display:block;position:relative;max-width:100%;margin:0 0 .4em;padding:0;color:#595959;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}.swal2-popup .swal2-actions{flex-wrap:wrap;align-items:center;justify-content:center;margin:1.25em auto 0;z-index:1}.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}.swal2-popup .swal2-actions:not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}.swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-confirm{width:2.5em;height:2.5em;margin:.46875em;padding:0;border:.25em solid transparent;border-radius:100%;border-color:transparent;background-color:transparent!important;color:transparent;cursor:default;box-sizing:border-box;-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-popup .swal2-actions.swal2-loading .swal2-styled.swal2-cancel{margin-right:30px;margin-left:30px}.swal2-popup .swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after{display:inline-block;width:15px;height:15px;margin-left:5px;border:3px solid #999;border-radius:50%;border-right-color:transparent;box-shadow:1px 1px 1px #fff;content:'';-webkit-animation:swal2-rotate-loading 1.5s linear 0s infinite normal;animation:swal2-rotate-loading 1.5s linear 0s infinite normal}.swal2-popup .swal2-styled{margin:.3125em;padding:.625em 2em;font-weight:500;box-shadow:none}.swal2-popup .swal2-styled:not([disabled]){cursor:pointer}.swal2-popup .swal2-styled.swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#3085d6;color:#fff;font-size:1.0625em}.swal2-popup .swal2-styled.swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#aaa;color:#fff;font-size:1.0625em}.swal2-popup .swal2-styled:focus{outline:0;box-shadow:0 0 0 2px #fff,0 0 0 4px rgba(50,100,150,.4)}.swal2-popup .swal2-styled::-moz-focus-inner{border:0}.swal2-popup .swal2-footer{justify-content:center;margin:1.25em 0 0;padding:1em 0 0;border-top:1px solid #eee;color:#545454;font-size:1em}.swal2-popup .swal2-image{max-width:100%;margin:1.25em auto}.swal2-popup .swal2-close{position:absolute;top:0;right:0;justify-content:center;width:1.2em;height:1.2em;padding:0;transition:color .1s ease-out;border:none;border-radius:0;outline:initial;background:0 0;color:#ccc;font-family:serif;font-size:2.5em;line-height:1.2;cursor:pointer;overflow:hidden}.swal2-popup .swal2-close:hover{-webkit-transform:none;transform:none;color:#f27474}.swal2-popup>.swal2-checkbox,.swal2-popup>.swal2-file,.swal2-popup>.swal2-input,.swal2-popup>.swal2-radio,.swal2-popup>.swal2-select,.swal2-popup>.swal2-textarea{display:none}.swal2-popup .swal2-content{justify-content:center;margin:0;padding:0;color:#545454;font-size:1.125em;font-weight:300;line-height:normal;z-index:1;word-wrap:break-word}.swal2-popup #swal2-content{text-align:center}.swal2-popup .swal2-checkbox,.swal2-popup .swal2-file,.swal2-popup .swal2-input,.swal2-popup .swal2-radio,.swal2-popup .swal2-select,.swal2-popup .swal2-textarea{margin:1em auto}.swal2-popup .swal2-file,.swal2-popup .swal2-input,.swal2-popup .swal2-textarea{width:100%;transition:border-color .3s,box-shadow .3s;border:1px solid #d9d9d9;border-radius:.1875em;background:inherit;font-size:1.125em;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);box-sizing:border-box}.swal2-popup .swal2-file.swal2-inputerror,.swal2-popup .swal2-input.swal2-inputerror,.swal2-popup .swal2-textarea.swal2-inputerror{border-color:#f27474!important;box-shadow:0 0 2px #f27474!important}.swal2-popup .swal2-file:focus,.swal2-popup .swal2-input:focus,.swal2-popup .swal2-textarea:focus{border:1px solid #b4dbed;outline:0;box-shadow:0 0 3px #c4e6f5}.swal2-popup .swal2-file::-webkit-input-placeholder,.swal2-popup .swal2-input::-webkit-input-placeholder,.swal2-popup .swal2-textarea::-webkit-input-placeholder{color:#ccc}.swal2-popup .swal2-file:-ms-input-placeholder,.swal2-popup .swal2-input:-ms-input-placeholder,.swal2-popup .swal2-textarea:-ms-input-placeholder{color:#ccc}.swal2-popup .swal2-file::-ms-input-placeholder,.swal2-popup .swal2-input::-ms-input-placeholder,.swal2-popup .swal2-textarea::-ms-input-placeholder{color:#ccc}.swal2-popup .swal2-file::placeholder,.swal2-popup .swal2-input::placeholder,.swal2-popup .swal2-textarea::placeholder{color:#ccc}.swal2-popup .swal2-range{margin:1em auto;background:inherit}.swal2-popup .swal2-range input{width:80%}.swal2-popup .swal2-range output{width:20%;font-weight:600;text-align:center}.swal2-popup .swal2-range input,.swal2-popup .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}.swal2-popup .swal2-input{height:2.625em;padding:0 .75em}.swal2-popup .swal2-input[type=number]{max-width:10em}.swal2-popup .swal2-file{background:inherit;font-size:1.125em}.swal2-popup .swal2-textarea{height:6.75em;padding:.75em}.swal2-popup .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:inherit;color:#545454;font-size:1.125em}.swal2-popup .swal2-checkbox,.swal2-popup .swal2-radio{align-items:center;justify-content:center;background:inherit}.swal2-popup .swal2-checkbox label,.swal2-popup .swal2-radio label{margin:0 .6em;font-size:1.125em}.swal2-popup .swal2-checkbox input,.swal2-popup .swal2-radio input{margin:0 .4em}.swal2-popup .swal2-validation-message{display:none;align-items:center;justify-content:center;padding:.625em;background:#f0f0f0;color:#666;font-size:1em;font-weight:300;overflow:hidden}.swal2-popup .swal2-validation-message::before{display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center;content:'!';zoom:normal}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@-moz-document url-prefix(){.swal2-close:focus{outline:2px solid rgba(50,100,150,.4)}}.swal2-icon{position:relative;justify-content:center;width:5em;height:5em;margin:1.25em auto 1.875em;border:.25em solid transparent;border-radius:50%;line-height:5em;cursor:default;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;zoom:normal}.swal2-icon::before{display:flex;align-items:center;height:92%;font-size:3.75em}.swal2-icon.swal2-error{border-color:#f27474}.swal2-icon.swal2-error .swal2-x-mark{position:relative;flex-grow:1}.swal2-icon.swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-warning{border-color:#facea8;color:#f8bb86}.swal2-icon.swal2-warning::before{content:'!'}.swal2-icon.swal2-info{border-color:#9de0f6;color:#3fc3ee}.swal2-icon.swal2-info::before{content:'i'}.swal2-icon.swal2-question{border-color:#c9dae1;color:#87adbd}.swal2-icon.swal2-question::before{content:'?'}.swal2-icon.swal2-question.swal2-arabic-question-mark::before{content:'؟'}.swal2-icon.swal2-success{border-color:#a5dc86}.swal2-icon.swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-radius:50%}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=left]{top:-.4375em;left:-2.0635em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:3.75em 3.75em;transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}.swal2-icon.swal2-success [class^=swal2-success-circular-line][class$=right]{top:-.6875em;left:1.875em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 3.75em;transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}.swal2-icon.swal2-success .swal2-success-ring{position:absolute;top:-.25em;left:-.25em;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%;z-index:2;box-sizing:content-box}.swal2-icon.swal2-success .swal2-success-fix{position:absolute;top:.5em;left:1.625em;width:.4375em;height:5.625em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);z-index:1}.swal2-icon.swal2-success [class^=swal2-success-line]{display:block;position:absolute;height:.3125em;border-radius:.125em;background-color:#a5dc86;z-index:2}.swal2-icon.swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.875em;width:1.5625em;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-progress-steps{align-items:center;margin:0 0 1.25em;padding:0;background:inherit;font-weight:600}.swal2-progress-steps li{display:inline-block;position:relative}.swal2-progress-steps .swal2-progress-step{width:2em;height:2em;border-radius:2em;background:#3085d6;color:#fff;line-height:2em;text-align:center;z-index:20}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#3085d6}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}.swal2-progress-steps .swal2-progress-step-line{width:2.5em;height:.4em;margin:0 -1px;background:#3085d6;z-index:10}[class^=swal2]{-webkit-tap-highlight-color:transparent}.swal2-show{-webkit-animation:swal2-show .3s;animation:swal2-show .3s}.swal2-show.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-hide{-webkit-animation:swal2-hide .15s forwards;animation:swal2-hide .15s forwards}.swal2-hide.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-rtl .swal2-close{right:auto;left:0}.swal2-animate-success-icon .swal2-success-line-tip{-webkit-animation:swal2-animate-success-line-tip .75s;animation:swal2-animate-success-line-tip .75s}.swal2-animate-success-icon .swal2-success-line-long{-webkit-animation:swal2-animate-success-line-long .75s;animation:swal2-animate-success-line-long .75s}.swal2-animate-success-icon .swal2-success-circular-line-right{-webkit-animation:swal2-rotate-success-circular-line 4.25s ease-in;animation:swal2-rotate-success-circular-line 4.25s ease-in}.swal2-animate-error-icon{-webkit-animation:swal2-animate-error-icon .5s;animation:swal2-animate-error-icon .5s}.swal2-animate-error-icon .swal2-x-mark{-webkit-animation:swal2-animate-error-x-mark .5s;animation:swal2-animate-error-x-mark .5s}@-webkit-keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes swal2-rotate-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll!important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:initial!important}}");
  }, function (t, e, n) {
    (function (e) {
      var n = 1 / 0,
          o = 9007199254740991,
          a = "[object Arguments]",
          r = "[object Function]",
          s = "[object GeneratorFunction]",
          i = "[object Symbol]",
          l = "object" == typeof e && e && e.Object === Object && e,
          c = "object" == typeof self && self && self.Object === Object && self,
          u = l || c || Function("return this")();

      function p(t, e) {
        for (var n = -1, o = e.length, a = t.length; ++n < o;) {
          t[a + n] = e[n];
        }

        return t;
      }

      var d = Object.prototype,
          f = d.hasOwnProperty,
          m = d.toString,
          w = u.Symbol,
          h = d.propertyIsEnumerable,
          g = w ? w.isConcatSpreadable : void 0,
          b = Math.max;

      function y(t) {
        return k(t) || function (t) {
          return function (t) {
            return x(t) && function (t) {
              return null != t && function (t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= o;
              }(t.length) && !function (t) {
                var e = function (t) {
                  var e = typeof t;
                  return !!t && ("object" == e || "function" == e);
                }(t) ? m.call(t) : "";
                return e == r || e == s;
              }(t);
            }(t);
          }(t) && f.call(t, "callee") && (!h.call(t, "callee") || m.call(t) == a);
        }(t) || !!(g && t && t[g]);
      }

      function v(t) {
        if ("string" == typeof t || function (t) {
          return "symbol" == typeof t || x(t) && m.call(t) == i;
        }(t)) return t;
        var e = t + "";
        return "0" == e && 1 / t == -n ? "-0" : e;
      }

      var k = Array.isArray;

      function x(t) {
        return !!t && "object" == typeof t;
      }

      var C,
          O,
          S = (C = function C(t, e) {
        return null == t ? {} : function (t, e) {
          return function (t, e, n) {
            for (var o = -1, a = e.length, r = {}; ++o < a;) {
              var s = e[o],
                  i = t[s];
              n(i, s) && (r[s] = i);
            }

            return r;
          }(t = Object(t), e, function (e, n) {
            return n in t;
          });
        }(t, function (t, e) {
          for (var n = -1, o = t ? t.length : 0, a = Array(o); ++n < o;) {
            a[n] = e(t[n], n, t);
          }

          return a;
        }(function t(e, n, o, a, r) {
          var s = -1,
              i = e.length;

          for (o || (o = y), r || (r = []); ++s < i;) {
            var l = e[s];
            n > 0 && o(l) ? n > 1 ? t(l, n - 1, o, a, r) : p(r, l) : a || (r[r.length] = l);
          }

          return r;
        }(e, 1), v));
      }, O = b(void 0 === O ? C.length - 1 : O, 0), function () {
        for (var t = arguments, e = -1, n = b(t.length - O, 0), o = Array(n); ++e < n;) {
          o[e] = t[O + e];
        }

        e = -1;

        for (var a = Array(O + 1); ++e < O;) {
          a[e] = t[e];
        }

        return a[O] = o, function (t, e, n) {
          switch (n.length) {
            case 0:
              return t.call(e);

            case 1:
              return t.call(e, n[0]);

            case 2:
              return t.call(e, n[0], n[1]);

            case 3:
              return t.call(e, n[0], n[1], n[2]);
          }

          return t.apply(e, n);
        }(C, this, a);
      });
      t.exports = S;
    }).call(this, n(11));
  }, function (t, e, n) {
    "use strict";

    var o = function o() {};

    t.exports = o;
  }, function (t, e, n) {
    "undefined" == typeof window ? t.exports = function () {
      return null;
    } : t.exports = n(12);
  }, function (t, e, n) {
    "use strict";
    /** @license React v16.8.4
     * react.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var o = n(8),
        a = "function" == typeof Symbol && Symbol.for,
        r = a ? Symbol.for("react.element") : 60103,
        s = a ? Symbol.for("react.portal") : 60106,
        i = a ? Symbol.for("react.fragment") : 60107,
        l = a ? Symbol.for("react.strict_mode") : 60108,
        c = a ? Symbol.for("react.profiler") : 60114,
        u = a ? Symbol.for("react.provider") : 60109,
        p = a ? Symbol.for("react.context") : 60110,
        d = a ? Symbol.for("react.concurrent_mode") : 60111,
        f = a ? Symbol.for("react.forward_ref") : 60112,
        m = a ? Symbol.for("react.suspense") : 60113,
        w = a ? Symbol.for("react.memo") : 60115,
        h = a ? Symbol.for("react.lazy") : 60116,
        g = "function" == typeof Symbol && Symbol.iterator;

    function b(t) {
      for (var e = arguments.length - 1, n = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, o = 0; o < e; o++) {
        n += "&args[]=" + encodeURIComponent(arguments[o + 1]);
      }

      !function (t, e, n, o, a, r, s, i) {
        if (!t) {
          if (t = void 0, void 0 === e) t = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var l = [n, o, a, r, s, i],
                c = 0;
            (t = Error(e.replace(/%s/g, function () {
              return l[c++];
            }))).name = "Invariant Violation";
          }
          throw t.framesToPop = 1, t;
        }
      }(!1, "Minified React error #" + t + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", n);
    }

    var y = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        v = {};

    function k(t, e, n) {
      this.props = t, this.context = e, this.refs = v, this.updater = n || y;
    }

    function x() {}

    function C(t, e, n) {
      this.props = t, this.context = e, this.refs = v, this.updater = n || y;
    }

    k.prototype.isReactComponent = {}, k.prototype.setState = function (t, e) {
      "object" != typeof t && "function" != typeof t && null != t && b("85"), this.updater.enqueueSetState(this, t, e, "setState");
    }, k.prototype.forceUpdate = function (t) {
      this.updater.enqueueForceUpdate(this, t, "forceUpdate");
    }, x.prototype = k.prototype;
    var O = C.prototype = new x();
    O.constructor = C, o(O, k.prototype), O.isPureReactComponent = !0;
    var S = {
      current: null
    },
        P = {
      current: null
    },
        B = Object.prototype.hasOwnProperty,
        E = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function j(t, e, n) {
      var o = void 0,
          a = {},
          s = null,
          i = null;
      if (null != e) for (o in void 0 !== e.ref && (i = e.ref), void 0 !== e.key && (s = "" + e.key), e) {
        B.call(e, o) && !E.hasOwnProperty(o) && (a[o] = e[o]);
      }
      var l = arguments.length - 2;
      if (1 === l) a.children = n;else if (1 < l) {
        for (var c = Array(l), u = 0; u < l; u++) {
          c[u] = arguments[u + 2];
        }

        a.children = c;
      }
      if (t && t.defaultProps) for (o in l = t.defaultProps) {
        void 0 === a[o] && (a[o] = l[o]);
      }
      return {
        $$typeof: r,
        type: t,
        key: s,
        ref: i,
        props: a,
        _owner: P.current
      };
    }

    function A(t) {
      return "object" == typeof t && null !== t && t.$$typeof === r;
    }

    var T = /\/+/g,
        _ = [];

    function L(t, e, n, o) {
      if (_.length) {
        var a = _.pop();

        return a.result = t, a.keyPrefix = e, a.func = n, a.context = o, a.count = 0, a;
      }

      return {
        result: t,
        keyPrefix: e,
        func: n,
        context: o,
        count: 0
      };
    }

    function M(t) {
      t.result = null, t.keyPrefix = null, t.func = null, t.context = null, t.count = 0, 10 > _.length && _.push(t);
    }

    function R(t, e, n) {
      return null == t ? 0 : function t(e, n, o, a) {
        var i = typeof e;
        "undefined" !== i && "boolean" !== i || (e = null);
        var l = !1;
        if (null === e) l = !0;else switch (i) {
          case "string":
          case "number":
            l = !0;
            break;

          case "object":
            switch (e.$$typeof) {
              case r:
              case s:
                l = !0;
            }

        }
        if (l) return o(a, e, "" === n ? "." + q(e, 0) : n), 1;
        if (l = 0, n = "" === n ? "." : n + ":", Array.isArray(e)) for (var c = 0; c < e.length; c++) {
          var u = n + q(i = e[c], c);
          l += t(i, u, o, a);
        } else if (u = null === e || "object" != typeof e ? null : "function" == typeof (u = g && e[g] || e["@@iterator"]) ? u : null, "function" == typeof u) for (e = u.call(e), c = 0; !(i = e.next()).done;) {
          l += t(i = i.value, u = n + q(i, c++), o, a);
        } else "object" === i && b("31", "[object Object]" == (o = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : o, "");
        return l;
      }(t, "", e, n);
    }

    function q(t, e) {
      return "object" == typeof t && null !== t && null != t.key ? function (t) {
        var e = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + t).replace(/[=:]/g, function (t) {
          return e[t];
        });
      }(t.key) : e.toString(36);
    }

    function z(t, e) {
      t.func.call(t.context, e, t.count++);
    }

    function H(t, e, n) {
      var o = t.result,
          a = t.keyPrefix;
      t = t.func.call(t.context, e, t.count++), Array.isArray(t) ? V(t, o, n, function (t) {
        return t;
      }) : null != t && (A(t) && (t = function (t, e) {
        return {
          $$typeof: r,
          type: t.type,
          key: e,
          ref: t.ref,
          props: t.props,
          _owner: t._owner
        };
      }(t, a + (!t.key || e && e.key === t.key ? "" : ("" + t.key).replace(T, "$&/") + "/") + n)), o.push(t));
    }

    function V(t, e, n, o, a) {
      var r = "";
      null != n && (r = ("" + n).replace(T, "$&/") + "/"), R(t, H, e = L(e, r, o, a)), M(e);
    }

    function I() {
      var t = S.current;
      return null === t && b("307"), t;
    }

    var N = {
      Children: {
        map: function map(t, e, n) {
          if (null == t) return t;
          var o = [];
          return V(t, o, null, e, n), o;
        },
        forEach: function forEach(t, e, n) {
          if (null == t) return t;
          R(t, z, e = L(null, null, e, n)), M(e);
        },
        count: function count(t) {
          return R(t, function () {
            return null;
          }, null);
        },
        toArray: function toArray(t) {
          var e = [];
          return V(t, e, null, function (t) {
            return t;
          }), e;
        },
        only: function only(t) {
          return A(t) || b("143"), t;
        }
      },
      createRef: function createRef() {
        return {
          current: null
        };
      },
      Component: k,
      PureComponent: C,
      createContext: function createContext(t, e) {
        return void 0 === e && (e = null), (t = {
          $$typeof: p,
          _calculateChangedBits: e,
          _currentValue: t,
          _currentValue2: t,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }).Provider = {
          $$typeof: u,
          _context: t
        }, t.Consumer = t;
      },
      forwardRef: function forwardRef(t) {
        return {
          $$typeof: f,
          render: t
        };
      },
      lazy: function lazy(t) {
        return {
          $$typeof: h,
          _ctor: t,
          _status: -1,
          _result: null
        };
      },
      memo: function memo(t, e) {
        return {
          $$typeof: w,
          type: t,
          compare: void 0 === e ? null : e
        };
      },
      useCallback: function useCallback(t, e) {
        return I().useCallback(t, e);
      },
      useContext: function useContext(t, e) {
        return I().useContext(t, e);
      },
      useEffect: function useEffect(t, e) {
        return I().useEffect(t, e);
      },
      useImperativeHandle: function useImperativeHandle(t, e, n) {
        return I().useImperativeHandle(t, e, n);
      },
      useDebugValue: function useDebugValue() {},
      useLayoutEffect: function useLayoutEffect(t, e) {
        return I().useLayoutEffect(t, e);
      },
      useMemo: function useMemo(t, e) {
        return I().useMemo(t, e);
      },
      useReducer: function useReducer(t, e, n) {
        return I().useReducer(t, e, n);
      },
      useRef: function useRef(t) {
        return I().useRef(t);
      },
      useState: function useState(t) {
        return I().useState(t);
      },
      Fragment: i,
      StrictMode: l,
      Suspense: m,
      createElement: j,
      cloneElement: function cloneElement(t, e, n) {
        null == t && b("267", t);
        var a = void 0,
            s = o({}, t.props),
            i = t.key,
            l = t.ref,
            c = t._owner;

        if (null != e) {
          void 0 !== e.ref && (l = e.ref, c = P.current), void 0 !== e.key && (i = "" + e.key);
          var u = void 0;

          for (a in t.type && t.type.defaultProps && (u = t.type.defaultProps), e) {
            B.call(e, a) && !E.hasOwnProperty(a) && (s[a] = void 0 === e[a] && void 0 !== u ? u[a] : e[a]);
          }
        }

        if (1 === (a = arguments.length - 2)) s.children = n;else if (1 < a) {
          u = Array(a);

          for (var p = 0; p < a; p++) {
            u[p] = arguments[p + 2];
          }

          s.children = u;
        }
        return {
          $$typeof: r,
          type: t.type,
          key: i,
          ref: l,
          props: s,
          _owner: c
        };
      },
      createFactory: function createFactory(t) {
        var e = j.bind(null, t);
        return e.type = t, e;
      },
      isValidElement: A,
      version: "16.8.4",
      unstable_ConcurrentMode: d,
      unstable_Profiler: c,
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: S,
        ReactCurrentOwner: P,
        assign: o
      }
    },
        $ = {
      default: N
    },
        K = $ && N || $;
    t.exports = K.default || K;
  }, function (t, e, n) {
    "use strict";
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */

    var o = Object.getOwnPropertySymbols,
        a = Object.prototype.hasOwnProperty,
        r = Object.prototype.propertyIsEnumerable;
    t.exports = function () {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

        for (var e = {}, n = 0; n < 10; n++) {
          e["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        }).join("")) return !1;
        var o = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          o[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
      } catch (t) {
        return !1;
      }
    }() ? Object.assign : function (t, e) {
      for (var n, s, i = function (t) {
        if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(t);
      }(t), l = 1; l < arguments.length; l++) {
        for (var c in n = Object(arguments[l])) {
          a.call(n, c) && (i[c] = n[c]);
        }

        if (o) {
          s = o(n);

          for (var u = 0; u < s.length; u++) {
            r.call(n, s[u]) && (i[s[u]] = n[s[u]]);
          }
        }
      }

      return i;
    };
  }, function (t, e, n) {
    "use strict";

    var o = n(10);

    function a() {}

    function r() {}

    r.resetWarningCache = a, t.exports = function () {
      function t(t, e, n, a, r, s) {
        if (s !== o) {
          var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw i.name = "Invariant Violation", i;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: r,
        resetWarningCache: a
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var o = n(2),
        a = n(0),
        r = n.n(a),
        s = n(3),
        i = n.n(s),
        l = n(4),
        c = n.n(l),
        u = n(1),
        p = n.n(u),
        d = n(5),
        f = n.n(d);

    function m(t) {
      return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function w(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    function h(t, e) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
      }
    }

    function g(t, e) {
      return !e || "object" !== m(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t) : e;
    }

    function b(t) {
      return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function y(t, e) {
      return (y = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    n.d(e, "withSwalInstance", function () {
      return C;
    });
    var v = ["title", "text", "type", "customClass", "showCancelButton", "showConfirmButton", "confirmButtonText", "confirmButtonColor", "confirmButtonClass", "cancelButtonClass", "cancelButtonText", "buttonsStyling", "reverseButtons", "imageUrl", "html", "animation", "inputValue", "inputPlaceholder", "showLoaderOnConfirm"],
        k = ["timer", "allowOutsideClick", "allowEscapeKey"],
        x = {
      allowOutsideClick: !1,
      allowEscapeKey: !1
    };

    var C = function C(t) {
      var e, n;
      return n = e = function (e) {
        function n(e, o) {
          var a;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, n), (a = g(this, b(n).call(this, e, o)))._show = !1, a._swal = Object.assign(t, {}), a;
        }

        var a, r, s;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && y(t, e);
        }(n, o["Component"]), a = n, (r = [{
          key: "componentDidMount",
          value: function value() {
            this.setupWithProps(this.props), this.props.onOutsideClick && this.registerOutsideClickHandler(this.props.onOutsideClick);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(t) {
            this.setupWithProps(t);
            var e = this.props.onOutsideClick,
                n = t.onOutsideClick;
            e !== n && (e && n ? (this.unregisterOutsideClickHandler(), this.registerOutsideClickHandler(n)) : e && !n ? this.unregisterOutsideClickHandler() : !e && n && this.registerOutsideClickHandler(n));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.unregisterOutsideClickHandler(), this.unbindEscapeKey();
          }
        }, {
          key: "setupWithProps",
          value: function value(t) {
            var e = this;
            !function (t) {
              k.forEach(function (e) {
                f()(void 0 === t[e], "%s has been removed from sweetalert-react, pass `show` props and use event hook instead.", "`".concat(e, "`"));
              });
            }(t);
            var n = t.show,
                o = t.onConfirm,
                a = t.onCancel,
                r = t.onClose,
                s = t.onEscapeKey;
            n ? (this._swal.fire(function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {},
                    o = Object.keys(n);
                "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
                  return Object.getOwnPropertyDescriptor(n, t).enumerable;
                }))), o.forEach(function (e) {
                  w(t, e, n[e]);
                });
              }

              return t;
            }({}, c()(t, v), x)).then(function () {
              e.handleClickConfirm(o);
            }, function (t) {
              e.handleClickCancel(a, t);
            }), this._show = !0, s && this.bindEscapeKey(s)) : this.handleClose(r);
          }
        }, {
          key: "registerOutsideClickHandler",
          value: function value(t) {
            var e, n;
            this._outsideClickHandler = (e = document.getElementsByClassName("sweet-alert")[0], n = t, function (t) {
              t.stopPropagation();

              for (var o = t.target; o.parentNode;) {
                if (o === e) return;
                o = o.parentNode;
              }

              n(t);
            }), this.enableOutsideClick();
          }
        }, {
          key: "unregisterOutsideClickHandler",
          value: function value() {
            this.disableOutsideClick(), this._outsideClickHandler = null;
          }
        }, {
          key: "enableOutsideClick",
          value: function value() {
            var t = this._outsideClickHandler;
            t && (document.addEventListener("mousedown", t), document.addEventListener("touchstart", t));
          }
        }, {
          key: "disableOutsideClick",
          value: function value() {
            var t = this._outsideClickHandler;
            t && (document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t));
          }
        }, {
          key: "bindEscapeKey",
          value: function value(t) {
            p.a.bind("esc", t);
          }
        }, {
          key: "unbindEscapeKey",
          value: function value() {
            p.a.unbind("esc");
          }
        }, {
          key: "handleClickConfirm",
          value: function value(t) {
            t && t();
          }
        }, {
          key: "handleClickCancel",
          value: function value(t) {
            t && t();
          }
        }, {
          key: "handleClose",
          value: function value(t) {
            this._show && (this._swal.close(), this.unbindEscapeKey(), t && t(), this._show = !1);
          }
        }, {
          key: "render",
          value: function value() {
            return null;
          }
        }]) && h(a.prototype, r), s && h(a, s), n;
      }(), e.propTypes = {
        title: r.a.string.isRequired,
        text: r.a.string,
        type: r.a.oneOf(["warning", "error", "success", "info", "input"]),
        customClass: r.a.string,
        showCancelButton: r.a.bool,
        showConfirmButton: r.a.bool,
        confirmButtonText: r.a.string,
        confirmButtonColor: r.a.string,
        confirmButtonClass: r.a.string,
        cancelButtonText: r.a.string,
        cancelButtonClass: r.a.string,
        reverseButtons: r.a.bool,
        buttonsStyling: r.a.bool,
        imageUrl: r.a.string,
        html: r.a.string,
        animation: r.a.oneOfType([r.a.bool, r.a.oneOf(["pop", "slide-from-top", "slide-from-bottom"])]),
        inputPlaceholder: r.a.string,
        inputValue: r.a.string,
        showLoaderOnConfirm: r.a.bool,
        show: r.a.bool,
        onConfirm: r.a.func,
        onCancel: r.a.func,
        onClose: r.a.func,
        onEscapeKey: r.a.func,
        onOutsideClick: r.a.func
      }, e.defaultProps = {
        text: null,
        type: null,
        customClass: null,
        showCancelButton: !1,
        showConfirmButton: !0,
        confirmButtonText: "OK",
        confirmButtonColor: "#aedef4",
        cancelButtonText: "Cancel",
        cancelButtonClass: null,
        confirmButtonClass: null,
        buttonsStyling: !0,
        reverseButtons: !1,
        imageUrl: null,
        html: null,
        animation: !0,
        inputPlaceholder: null,
        inputValue: null,
        showLoaderOnConfirm: !1,
        show: !1
      }, n;
    };

    e.default = C(i.a);
  }]);
});